<template>
	<div class="user-manage" :style="{ height: $pageHeight() + 'px' }">
		<topBar :scheduleMode="'userManage'" :userId="userId"></topBar>
		<div class="user-manage-top">
			<div class="create-user-btn" @click="createUser">
				<img src="../../assets/common/icons/createUser.png" />
				<span v-if="userType == 1">新增校领导</span>
				<span v-if="userType == 2">新增联络员</span>
			</div>
		</div>
		<div class="user-list">
			<div class="user-list-tabs">
				<div class="user-list-tabs-each" :class="userType == 1?'user-list-tabs-each-active':''"
					@click="chooseUserType(1)">
					<span>校领导</span>
				</div>
				<div class="user-list-tabs-each" :class="userType == 2?'user-list-tabs-each-active':''"
					@click="chooseUserType(2)">
					<span>联络员</span>
				</div>
			</div>
			<div class="user-list-table" v-if="userList.length > 1">
				<div class="user-list-table-each" v-for="(item, index) in userList" :key="index"
					:class="index?index%2 == 0?'user-list-table-each-odd':'user-list-table-each-even':''">
					<div class="user-list-table-each-text" :class="index == 0?'user-list-table-head-text':''">
						<span>{{index == 0?'序号':index}}</span>
					</div>
					<div class="user-list-table-each-text" :class="index == 0?'user-list-table-head-text':''">
						<span>{{item.number}}</span>
					</div>
					<div class="user-list-table-each-text" :class="index == 0?'user-list-table-head-text':''">
						<span>{{item.name}}</span>
					</div>
					<div class="user-list-table-each-text" :class="index == 0?'user-list-table-head-text':''">
						<span>{{item.roleText}}</span>
					</div>
					<div class="user-list-table-each-text" :class="index == 0?'user-list-table-head-text':''">
						<span>{{item.belongText}}</span>
					</div>
					<div class="user-list-table-each-text" :class="index == 0?'user-list-table-head-text':''"
						style="flex:3;">
						<span>{{item.manager}}</span>
					</div>
					<div v-if="index == 0" class="user-list-table-btns">
						<span :class="index == 0?'user-list-table-head-text':''">操作</span>
					</div>
					<div v-else class="user-list-table-btns">
						<img class="user-list-table-btns-edit" @click="editUserInfo(item)"
							src="../../assets/common/icons/editScheduleIcon.png" />
						<el-popover placement="left" width="400" trigger="click" ref="deletePopover"
							popper-class="user-list-table-btns-popover">
							<img src="../../assets/common/icons/deleteScheduleIcon.png" slot="reference" />
							<tipsModal :modalTitle="'温馨提示'" :modalContent="'确定删除此用户？'" @hideModal="hideModal(index - 1)"
								@modalConfirm="modalConfirm(index - 1, item)">
							</tipsModal>
						</el-popover>
					</div>
				</div>
			</div>
			<div class="user-list-no-data" v-else>
				<img src="../../assets/common/scheduleListNoData.png" />
			</div>
		</div>
		<el-dialog :visible.sync="isShowEditUser" :close-on-click-modal="false">
			<div slot="title" class="dialog-title">
				<span v-if="userType == 1">校领导详情</span>
				<span v-if="userType == 2">联络员详情</span>
			</div>
			<editUser :useMode="useMode" :userType="userType" @confirmEditUser="confirmEditUser"
				:userRolesList="userRolesList" :userInfo="userInfo" v-if="showEditUser"></editUser>
		</el-dialog>
	</div>
</template>

<script>
	import topBar from '../../components/common/TopBar.vue';
	import tipsModal from '../../components/tools/TipsModal.vue';
	import editUser from '../../components/user/EditUser.vue';
	export default {
		components: {
			topBar,
			tipsModal,
			editUser
		},
		props: {},
		data() {
			return {
				userId: -1, //当前登录用户Id
				userType: 1, //用户身份类别
				userList: [], //用户列表
				isShowEditUser: false, //是否显示编辑用户弹窗
				showEditUser: false, //是否显示编辑用户弹窗（dialog中）
				useMode: '', //当前操作
				page: 1, //查询用户的页数
				size: 10, //每次查询的条数
				userRolesList: [], //用户角色列表
				userInfo: {}, //用户信息
				loading: '', //加载中
			}
		},
		mounted() {
			let that = this;
			that.$nextTick(() => {
				let userInfo = JSON.parse(localStorage.getItem('userInfo'));
				that.userId = userInfo.id;
				that.getAllRoles();
			})
		},
		methods: {
			//选择用户身份类别
			chooseUserType(flag) {
				let that = this;
				that.userType = flag;
				if (flag == 1) {
					that.getUsersList(true);
				} else if (flag == 2) {
					that.getUsersList(true);
				}
			},
			//点击创建用户
			createUser() {
				let that = this;
				that.useMode = 'create';
				that.isShowEditUser = true;
				that.showEditUser = true;
				that.userInfo = {};
			},
			//点击打开编辑用户信息弹窗
			editUserInfo(userInfo) {
				let that = this;
				that.useMode = 'edit';
				that.isShowEditUser = true;
				that.showEditUser = true;
				that.userInfo = userInfo;
			},
			//点击隐藏删除用户提示框
			hideModal(index) {
				let that = this;
				that.$refs['deletePopover'][index].doClose();
			},
			//点击确认删除用户
			modalConfirm(index, userInfo) {
				let that = this;
				that.$refs['deletePopover'][index].doClose();
				that.deleteUser(userInfo);
			},
			//删除用户
			deleteUser(userInfo) {
				let that = this;
				let params = userInfo;
				that.$api.deleteUser(params).then(res => {
					console.log(res)
					if (res.code == 1) {
						that.getUsersList(true);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//确认编辑用户
			confirmEditUser() {
				let that = this;
				that.isShowEditUser = false;
				that.showEditUser = false;
				that.getUsersList(true);
			},
			//获取所有用户权限
			getAllRoles() {
				let that = this;
				that.$api.getAllRoles().then(res => {
					console.log(res)
					if (res.code == 1) {
						that.userRolesList = res.data;
						that.getUsersList(true);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//查询校领导列表
			getUsersList(update) {
				let that = this;
				if (update) {
					that.page = 1;
				}
				that.loading = that.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				let params = {
					page: that.page,
					size: that.size
				};
				let getUserListFun;
				if (that.userType == 1) {
					getUserListFun = that.$api.getLeaders(params);
				} else if (that.userType == 2) {
					getUserListFun = that.$api.getLiaisons(params);
				}
				getUserListFun.then(res => {
					console.log(res)
					that.loading.close();
					if (res.code == 1) {
						that.userList = [{
							number: '工号',
							name: '称谓',
							role: '',
							roleText: '所属角色',
							belong: '',
							belongText: '所属部门',
							manager: that.userType == 1 ? '联络员' : '校领导'
						}];
						if (res.data.length > 0) {
							res.data.forEach((item, index) => {
								that.userRolesList.forEach((roleItem, roleIndex) => {
									if (item.role == roleItem.id) {
										item.roleText = roleItem.detail;
									}
								})
								if (item.belong == 1) {
									item.belongText = '党办';
								} else if (item.belong == 2) {
									item.belongText = '校办';
								} else {
									item.belongText = '/';
								}
								if (!item.manager) {
									item.manager = "/";
								}
							})
						}
						that.userList = that.userList.concat(res.data);
					}
				}).catch(err => {
					console.log(err)
					that.loading.close();
				})
			}
		},
	}
</script>

<style lang="scss">
	.user-manage {
		.user-manage-top {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-end;

			.create-user-btn {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;
				background-color: #04BD63;
				cursor: pointer;

				img {}

				span {
					font-weight: 400;
					color: #FFFFFF;
				}
			}
		}

		.user-list {
			.user-list-tabs {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: flex-start;

				.user-list-tabs-each {
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: center;
					background-color: #D8E0E6;
					cursor: pointer;

					span {
						font-weight: 400;
						color: #666666;
					}
				}

				.user-list-tabs-each-active {
					background-color: #3F79F7;

					span {
						color: #fff;
					}
				}
			}

			.user-list-table {
				display: flex;
				flex-direction: column;
				border-bottom: 1px solid #999999;
				background-color: #F2F8FF;

				.user-list-table-head-text {
					font-weight: 400;
					color: #666666;
				}

				.user-list-table-each {
					display: flex;
					flex-direction: row;
					align-items: stretch;
					justify-content: flex-start;
					border: 1px solid #999999;
					border-bottom: 0;
					width: 100%;

					.user-list-table-each-text {
						display: flex;
						flex-direction: row;
						align-items: center;
						justify-content: center;
						border-right: 1px solid #999999;
						flex: 1;
						flex-shrink: 0;

						span {
							font-weight: 400;
							color: #333333;
						}
					}

					.user-list-table-btns {
						display: flex;
						flex-direction: row;
						align-items: center;
						justify-content: center;

						img {
							cursor: pointer;
						}
					}
				}

				.user-list-table-each-even {
					background-color: #CBE4FD;
				}

				.user-list-table-each-odd {
					background-color: #F4F4F4;
				}

				.dialog-title-delete {
					justify-content: flex-start;
				}
			}

			.user-list-no-data {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;

				img {}
			}
		}
	}

	.user-list-table-btns-popover {
		padding: 0;
		border: 0;
		overflow: hidden;
	}

	.dialog-title {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;

		span {
			font-weight: 400;
			color: #333333;
		}
	}

	@media screen and (min-width: 1024px) {
		.user-manage {
			.user-manage-top {
				padding: 18px 18px 6px;
		
				.create-user-btn {
					padding: 6px 14px;
					border-radius: 9px;
		
					img {
						width: 23px;
						height: 23px;
						margin: 0 7px 0 0;
					}
		
					span {
						font-size: 15px;
					}
				}
			}
		
			.user-list {
				padding: 0 28px;
		
				.user-list-tabs {
					.user-list-tabs-each {
						padding: 8px 16px;
						margin: 0 9px 0 0;
						border-radius: 4px 4px 0 0;
		
						span {
							font-size: 15px;
						}
					}
				}
		
				.user-list-table {
					.user-list-table-head-text {
						font-size: 14px;
						padding: 11px 0;
					}
		
					.user-list-table-each {
						.user-list-table-each-text {
							min-width: 83px;
		
							span {
								font-size: 14px;
							}
						}
		
						.user-list-table-btns {
							padding: 6px 20px;
							width: 120px;
		
							img {
								width: 25px;
								height: 25px;
							}
		
							.user-list-table-btns-edit {
								margin: 0 9px;
							}
						}
		
						.el-popover__reference-wrapper {
							height: 23px;
							width: 23px;
						}
					}
				}
		
				.user-list-no-data {
					img {
						width: 500px;
					}
				}
			}
		}
		
		.user-list-table-btns-popover {
			border-radius: 11px;
		}
		
		.dialog-title {
			span {
				font-size: 18px;
			}
		}
	}

	@media screen and (min-width: 1280px) {}

	@media screen and (min-width: 1366px) {}

	@media screen and (min-width: 1440px) {}

	@media screen and (min-width: 1680px) {
		.user-manage {
			.user-manage-top {
				padding: 30px 30px 10px;

				.create-user-btn {
					padding: 18px 24px;
					border-radius: 14px;

					img {
						width: 40px;
						height: 40px;
						margin: 0 10px 0 0;
					}

					span {
						font-size: 25px;
					}
				}
			}

			.user-list {
				padding: 0 48px;

				.user-list-tabs {
					.user-list-tabs-each {
						padding: 14px 28px;
						margin: 0 15px 0 0;
						border-radius: 7px 7px 0 0;

						span {
							font-size: 25px;
						}
					}
				}

				.user-list-table {
					.user-list-table-head-text {
						font-size: 21px;
						padding: 16px 0;
					}

					.user-list-table-each {
						.user-list-table-each-text {
							min-width: 86px;

							span {
								font-size: 22px;
							}
						}

						.user-list-table-btns {
							padding: 6px 20px;
							width: 190px;

							img {
								width: 40px;
								height: 40px;
							}

							.user-list-table-btns-edit {
								margin: 0 16px;
							}
						}

						.el-popover__reference-wrapper {
							height: 40px;
							width: 40px;
						}
					}
				}

				.user-list-no-data {
					img {
						width: 700px;
					}
				}
			}
		}

		.user-list-table-btns-popover {
			border-radius: 11px;
		}

		.dialog-title {
			span {
				font-size: 29px;
			}
		}
	}

	@media screen and (min-width: 1920px) {}
</style>